<template>
  <div style="height: 100%; background: #003d66; color: #ffffff">
    <Head></Head>
    <div
        style="
        background: #ffffff;
        position: fixed;
        top: 4.5rem;
        left: 0;
        z-index: 999;
        height: 100%;
        width: 100%;
        overflow: auto;
        font-size: 18px;
      "
    >
      <div style="background: #003d66; padding: 20px">
        <div class="w-100 d-flex align-items-center justify-content-between">
          <p style="font-weight: 600; font-size: 30px; color: #ffffff">
            节能降碳/降本增效数据总览
          </p>
          <div style="width: 30%" class="d-flex justify-content-between">
            <div>
              {{ $t("overview_static.common.industry") }}:<el-select
                disabled
                v-model="value"
                class="m-2"
            >
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
            </div>
            <div>
              {{ $t("Apply") }}:<el-select disabled v-model="value1" class="m-2">
              <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
            </div>
          </div>
        </div>
        <div style="width: 100%; display: flex; justify-content: space-around">
          <div
              v-for="(a, i) in topDataTop"
              :key="i"
              :style="{ width: i != 1 ? (i == 0 ? '24%' : '20%') : '30%' }"
          >
            <div
                style="
                width: 100%;
                height: 100%;
                background: #ebeff2;
                display: flex;
                align-content: space-between;
                justify-content: space-between;
                padding: 10px;
                box-sizing: border-box;
                border-radius: 4px;
              "
            >
              <div
                  :style="{
                  minWidth: i != 1 ? '100%' : '62%',
                  position: 'relative',
                }"
                  class="shouyi"
              >
                <div
                    style="
                    width: 100%;
                    color: #606163;
                    font-size: 22px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div>
                    {{ a.title }}
                  </div>
                  <div style="font-size: 16px">
                    <span
                        style="
                        color: #495057;
                        padding-right: 5px;
                        text-decoration: underline;
                      "
                    >{{ a.tongbi }}</span
                    ><span style="color: #ed5e5e">{{ a.tongbiVal }}</span>
                  </div>
                </div>
                <div
                    style="
                    width: 100%;
                    display: flex;
                    justify-content: start;
                    align-items: baseline;
                  "
                >
                  <span
                      style="
                      font-size: 38px;
                      color: #3a4d59;
                      font-weight: 500;
                      padding-right: 5px;
                    "
                  >{{ a.value.num }}</span
                  >
                  <div style="color: #606163; margin-left: 10px">
                    <div style="color: #e15c5e; font-size: 14px">
                      {{ a.value.unit }}
                    </div>
                    <div style="font-size: 18px">{{ a.value.unit1 }}</div>
                  </div>
                </div>
                <div
                    style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div
                      style="
                      width: 100%;
                      display: flex;
                      align-items: baseline;
                      font-size: 16px;
                      color: #606163;
                    "
                  >
                    <div style="display: flex; align-items: baseline">
                      <div>{{ a.text }}</div>
                      <div
                          style="
                          color: #495057;
                          font-size: 18px;
                          margin-left: 10px;
                        "
                      >
                        {{ a.subtext }}
                      </div>
                    </div>
                    <div
                        v-if="i == 2 || i == 1"
                        style="
                        margin-left: 5px;
                        display: flex;
                        align-items: baseline;
                      "
                    >
                      <div style="margin-right: 5px">✖️</div>
                      <div>{{ a.subtextname }}</div>
                    </div>
                  </div>

                  <img
                      :style="{ width: '48px', height: '48px' }"
                      :src="a.imgurl"
                      alt=""
                  />
                </div>
              </div>
              <div
                  style="
                  border-left: 2px solid #ccc;
                  font-size: 18px;
                  color: #606163;
                  padding-left: 10px;
                  margin-left: 10px;
                  width: 38%;
                "
                  v-if="i == 1"
              >
                <div>{{ $t("System back pressure improves CS") }}</div>
                <div
                    style="color: #495057; font-size: 22px; text-align: center"
                >
                  {{ language == "ch" ? "112.5" : "1,125K"
                  }}<span style="font-size: 18px">
                    {{ $t("ten thousands") }}</span
                >
                </div>
                <div>{{ $t("Unit frequency conversion CS income") }}</div>
                <div
                    style="color: #495057; font-size: 22px; text-align: center"
                >
                  {{ language == "ch" ? "11.46" : "114.6K" }}
                  <span style="font-size: 18px">
                    {{ $t("ten thousands") }}</span
                  >
                </div>
                <div>{{ $t("Unit Load Tracking CS Benefit") }}</div>
                <div
                    style="color: #495057; font-size: 22px; text-align: center"
                >
                  {{ language == "ch" ? "4.91" : "49.1K" }}
                  <span style="font-size: 18px">
                    {{ $t("ten thousands") }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="background: #ffffff; padding: 20px">
        <p
            style="
            font-weight: 600;
            font-size: 30px;
            line-height: 17px;
            color: #495057;
            margin-top: 20px;
          "
        >
          {{ $t("UN energy saving analysis") }}
        </p>
        <div style="width: 100%; margin-top: 20px; height: 600px">
          <a-row
              style="
              color: #000000;
              height: 600px;
              display: flex;
              justify-content: space-between;
            "
          >
            <a-col
                span="7"
                class="flex-wrap"
                style="display:flex;background: #EBEFF2;box-shadow: 0px 1px 2px rgba(56, 65, 74, 0.14902);height:100%;padding:20px 10px;align-items:center;border-radius: 4px;"
            >
              <div style="height:50%;width:100%">
                <div style="font-size: 20px;color: #606163;">
                  <span
                      :style="{
                      display: language != 'ch' ? 'block' : 'inline-block'
                    }"
                  >{{ $t("Operating status") }}：</span
                  ><span style="color:#35D283">{{ $t("Energy saving") }}</span>
                </div>
                <div
                    :style="{
                  width:'100%',
                    height:
                      language != 'ch'
                        ? 'calc(100% - 150px)'
                        : 'calc(100% - 50px)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }"
                >
                  <img
                      style="width: 249px; height: 200px"
                      :src="imgUrl"
                      alt=""
                  />
                </div>
              </div>

              <a-row
                  style="
                  width: 100%;
                  color: #3e4043;
                  height: 50%;
                  line-height: 45px;
                  font-weight: 500;
                  background: #fff;
                  font-size: 19px;
                "
                  class="d-flex flex-wrap justify-content-start align-content-start"
              >
                <a-col
                    span="24"
                    style="
                    color: #495057;
                    font-weight: 600;
                    font-size: 24px;
                    padding-left: 10px;
                  "
                    class="mb-3"
                >
                  {{ $t("Unit Information") }}-{{equip_data&&equip_data.name}}
                </a-col
                >
                <a-col
                    span="12"
                    v-for="(item, i) in deviceInfo"
                    :key="i"
                    style="
                    padding-left: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: start;
                    text-align: left;
                    height:50px;
                  "
                    class="mb-1"
                >
                  <div class="info-bg text-end pe-2" style="width: 42%; line-height: 50px">
                    {{ item.name }}
                  </div>
                  <div
                      class="ms-2"
                      style="
                      width: 58%;
                      text-align: left;
                      margin-left: 10px;
                      line-height: 50px;
                    "
                  >
                    {{ item.value }}
                  </div>
                </a-col>
              </a-row>
            </a-col>
            <a-col
                span="10"
                style="
                background: #ebeff2;
                box-shadow: 0px 1px 2px rgba(56, 65, 74, 0.14902);
                height: 100%;
                padding: 20px 10px;
                align-items: center;
                border-radius: 4px;
                padding: 20px;
              "
            >
              <div style="background: #fff; width: 100%; height: 100%">
                <p
                    style="
                    font-weight: 400;
                    font-size: 20px;
                    color: #495057;
                    padding: 20px 20px 0;
                  "
                >
                  {{ $t("UN energy saving chart") }}
                </p>
                <div style="width: 100%; height: 490px" id="chart9"></div>
              </div>
            </a-col>
            <a-col span="6" style="height: 100%">
              <a-row
                  style="
                  height: 100%;
                  display: flex;
                  flex-wrap: wrap;
                  box-sizing: border-box;
                "
              >
                <a-col
                    style="
                    height: 49%;
                    background: #ebeff2;
                    box-shadow: 0px 1px 2px rgba(56, 65, 74, 0.14902);
                    border-radius: 4px;
                    margin: 5px;
                    box-sizing: border-box;
                    margin-top: 0px;
                  "
                    span="11"
                >
                  <div style="padding: 10px; display: flex; height: 100%">
                    <div
                        style="
                        display: flex;
                        align-content: space-between;
                        height: 100%;
                        flex-wrap: wrap;
                      "
                    >
                      <div
                          style="
                          width: 100%;
                          font-weight: 500;
                          font-size: 20px;
                          color: #606163;
                          display: flex;
                        "
                      >
                        <p
                            style="width: 80%; min-height: 60px; min-height: 60px"
                        >
                          {{ $t("Savings on electricity 30d") }}
                        </p>
                        <img
                            style="width: 48px; height: 48px; margin-left: 10px"
                            src="./Iconshandian.png"
                            alt=""
                        />
                      </div>
                      <div
                          style="
                          width: 100%;
                          font-weight: 500;
                          font-size: 38px;
                          color: #606163;
                        "
                      >
                        27,971
                        <span style="font-size: 20px">{{ $t("Rmb") }}</span>
                      </div>
                      <div
                          style="
                          width: 100%;
                          font-size: 14px;
                          display: flex;
                          justify-content: end;
                        "
                      >
                        <span
                            style="
                            color: #495057;
                            padding-right: 5px;
                            text-decoration: underline;
                          "
                        >{{ $t("link relative ratio") }}</span
                        ><span style="color: #ed5e5e">+2.9%</span>
                      </div>
                    </div>
                  </div>
                </a-col>
                <a-col
                    style="
                    height: 49%;
                    background: #ebeff2;
                    box-shadow: 0px 1px 2px rgba(56, 65, 74, 0.14902);
                    border-radius: 4px;
                    margin: 5px;
                    box-sizing: border-box;
                    margin-top: 0px;
                  "
                    span="11"
                ><div style="padding: 10px; display: flex; height: 100%">
                  <div
                      style="
                        display: flex;
                        align-content: space-between;
                        height: 100%;
                        flex-wrap: wrap;
                      "
                  >
                    <div
                        style="
                          width: 100%;
                          font-weight: 500;
                          font-size: 20px;
                          color: #606163;
                          display: flex;
                        "
                    >
                      <p style="width: 80%; min-height: 60px">
                        {{ $t("CO2 emissions reduced 30d") }}
                      </p>
                      <img
                          style="
                            width: 45.01px;
                            height: 48px;
                            margin-left: 10px;
                          "
                          src="./paiqiIcon.png"
                          alt=""
                      />
                    </div>
                    <div
                        style="
                          width: 100%;
                          font-weight: 500;
                          font-size: 38px;
                          color: #606163;
                        "
                    >
                      47 <span style="font-size: 20px">{{ $t("Ton") }}</span>
                    </div>
                    <div
                        style="
                          width: 100%;
                          font-size: 14px;
                          display: flex;
                          justify-content: end;
                          height: 21px;
                        "
                    >
                        <span style="color: #495057; padding-right: 5px"></span
                        ><span style="color: #3a9b9a"></span>
                    </div>
                  </div></div
                ></a-col>
                <a-col
                    style="
                    height: 49%;
                    background: #ebeff2;
                    box-shadow: 0px 1px 2px rgba(56, 65, 74, 0.14902);
                    border-radius: 4px;
                    margin: 5px;
                    box-sizing: border-box;
                  "
                    span="11"
                ><div style="padding: 10px; display: flex; height: 100%">
                  <div
                      style="
                        display: flex;
                        align-content: space-between;
                        height: 100%;
                        flex-wrap: wrap;
                      "
                  >
                    <div
                        style="
                          width: 100%;
                          font-weight: 500;
                          font-size: 20px;
                          color: #606163;
                          display: flex;
                        "
                    >
                      <p style="width: 80%; min-height: 60px">
                        {{ $t("Electricity bill 30d") }}
                      </p>
                      <img
                          style="width: 48px; height: 48px; margin-left: 10px"
                          src="./shandian2.png"
                          alt=""
                      />
                    </div>
                    <div
                        style="
                          width: 100%;
                          font-weight: 500;
                          font-size: 38px;
                          color: #606163;
                        "
                    >
                      7,086
                      <span style="font-size: 20px">{{ $t("Rmb") }}</span>
                    </div>
                    <div
                        style="
                          width: 100%;
                          font-size: 14px;
                          display: flex;
                          justify-content: end;
                        "
                    >
                        <span
                            style="
                            color: #495057;
                            padding-right: 5px;
                            text-decoration: underline;
                          "
                        >{{ $t("link relative ratio") }}</span
                        ><span style="color: #3a9b9a">-3.5%</span>
                    </div>
                  </div>
                </div></a-col
                >
                <a-col
                    style="
                    height: 49%;
                    background: #ebeff2;
                    box-shadow: 0px 1px 2px rgba(56, 65, 74, 0.14902);
                    border-radius: 4px;
                    margin: 5px;
                    box-sizing: border-box;
                  "
                    span="11"
                ><div style="padding: 10px; display: flex; height: 100%">
                  <div
                      style="
                        display: flex;
                        align-content: space-between;
                        height: 100%;
                        flex-wrap: wrap;
                      "
                  >
                    <div
                        style="
                          width: 100%;
                          font-weight: 500;
                          font-size: 20px;
                          color: #606163;
                          display: flex;
                        "
                    >
                      <p style="width: 80%; min-height: 60px">
                        {{ $t("CO2 emissions 30d") }}
                      </p>
                      <img
                          style="
                            width: 45.01px;
                            height: 48px;
                            margin-left: 10px;
                          "
                          src="./paiqiIcon.png"
                          alt=""
                      />
                    </div>
                    <div
                        style="
                          width: 100%;
                          font-weight: 500;
                          font-size: 38px;
                          color: #606163;
                        "
                    >
                      12 <span style="font-size: 20px">{{ $t("Ton") }}</span>
                    </div>
                    <div
                        style="
                          width: 100%;
                          font-size: 14px;
                          display: flex;
                          justify-content: end;
                          height: 21px;
                        "
                    >
                        <span style="color: #495057; padding-right: 5px"></span
                        ><span style="color: #3a9b9a"></span>
                    </div>
                  </div></div
                ></a-col>
              </a-row>
            </a-col>
          </a-row>
        </div>
      </div>
      <div v-show="this.$route.query.index&&this.$route.query.index!=1" style="width:100%;padding:20px;margin-bottom:60px;height:600px">
        <p
            style="font-weight: 600;font-size: 30px;line-height: 17px;color: #495057;"
        >
          {{ $t("UN monitoring and analysis") }}
        </p>
        <div
            style="width:100%;height:100%;border: 10px solid rgb(235, 239, 242);border-radius: 4px;"
        >
          <div style="width:100%;height:500px" id="chart6"></div>
        </div>
      </div>
      <div style="height: 100px"></div>
    </div>
  </div>
</template>
<script>
import { chart6,chart9 } from "./chart";
import { reactive } from "vue";
import { useRoute } from "vue-router"
import { getInstancesDetailId } from "@/service";
import _ from 'loadsh'
// import { chart8, chart9 } from "./chart";
export default {
  setup() {
    const route = useRoute()
    const equip_data = reactive({});

    const data = localStorage.getItem('equip_id')
    getInstancesDetailId({id:route.query.equip_id||data}).then((res) => {
      if (res && res.payload) {
        Object.assign(equip_data, res.payload)
      }
    });
    return {
      equip_data
    };
  },
  name: "EnergyConsumption",
  data() {
    return {
      value: this.$t('overview_dynamic.industy_dict["电力"]'),
      value1: this.$t('overview_dynamic.industy_dict["凝汽器抽真空"]'),
      options: [
        {
          value: this.$t('overview_dynamic.industy_dict["电力"]'),
          label: this.$t('overview_dynamic.industy_dict["电力"]'),
        },
        {
          value: this.$t('overview_dynamic.industy_dict["制药"]'),
          label: this.$t('overview_dynamic.industy_dict["制药"]'),
        },
        {
          value: this.$t('overview_dynamic.industy_dict["化工"]'),
          label: this.$t('overview_dynamic.industy_dict["化工"]'),
        },
        {
          value: this.$t('overview_dynamic.industy_dict["油气"]'),
          label: this.$t('overview_dynamic.industy_dict["油气"]'),
        },
        {
          value: this.$t('overview_dynamic.industy_dict["通用"]'),
          label: this.$t('overview_dynamic.industy_dict["通用"]'),
        },
        {
          value: this.$t('overview_dynamic.industy_dict["造纸"]'),
          label: this.$t('overview_dynamic.industy_dict["造纸"]'),
        },
        {
          value: this.$t('overview_dynamic.industy_dict["核电"]'),
          label: this.$t('overview_dynamic.industy_dict["核电"]'),
        },
      ],
      options1: [
        {
          value: this.$t('overview_dynamic.industy_dict["凝汽器抽真空"]'),
          label: this.$t('overview_dynamic.industy_dict["凝汽器抽真空"]'),
        },
        {
          value: "制药蒸馏",
          label: "制药蒸馏",
        },
        {
          value: "湿法脱硫氧化",
          label: "湿法脱硫氧化",
        },
        {
          value: this.$t('overview_dynamic.industy_dict["飞灰输送"]'),
          label: this.$t('overview_dynamic.industy_dict["飞灰输送"]'),
        },
        {
          value: this.$t('overview_dynamic.industy_dict["烟气脱硫"]'),
          label: this.$t('overview_dynamic.industy_dict["烟气脱硫"]'),
        },
      ],
      data6: {
        ch: [
          "08月10日",
          "08月11日",
          "08月12日",
          "08月13日",
          "08月14日",
          "08月15日",
          "08月16日",
          "08月17日",
          "08月18日",
          "08月19日",
          "08月20日",
          "08月21日"
        ],
        en: [
          "August 10",
          "August 11",
          "August 12",
          "August 13",
          "August 14",
          "August 15",
          "August 16",
          "August 17",
          "August 18",
          "August 19",
          "August 20",
          "August 21"
        ]
      },
      data9: {
        ch: [
          "8-01",
          "8-03",
          "8-05",
          "8-07",
          "8-09",
          "8-11",
          "8-13",
          "8-15",
          "8-17",
          "8-19",
          "8-21",
          "8-23",
          "8-25",
          "8-27",
          "8-29",
        ],
        en: [
          "Aug '01",
          "Aug '03",
          "Aug '05",
          "Aug '07",
          "Aug '09",
          "Aug '11",
          "Aug '13",
          "Aug '15",
          "Aug '17",
          "Aug '19",
          "Aug '21",
          "Aug '23",
          "Aug '25",
          "Aug '27",
          "Aug '29",
        ],
      },
    };
  },
  computed: {
    language(){
      return localStorage.getItem("language") || "ch";
    },
    topDataTop() {
      let topDataTop = [
        {
          title: "智能系统年度总收益",
          value: {
            num: this.language == "ch" ? "157.17" : "1,571.7K",
            unit: "",
            unit1: this.$t("ten thousands"),
          },
          text: "",
          subtext: "",
          tongbi: this.$t("Year-on-year"),
          tongbiVal: "+13%",
          imgurl: require("./dollar.png"),
        },
        {
          title: this.$t("SA coal saving income"),
          value: {
            num: this.language == "ch" ? "128.86" : "1,288.6K",
            unit: "",
            unit1: this.$t("ten thousands"),
          },
          text: this.$t("Total coal saving"),
          subtext: "1,718.18 " + this.$t("Ton"),
          subtextname: this.$t("Coal price today"),
          tongbi: this.$t("Year-on-year"),
          tongbiVal: "+12%",
          imgurl: require("./meiqi.png"),
        },
        {
          title: this.$t("SA CO2 emission benefit"),
          value: {
            num: this.language == "ch" ? "25.91" : "259.1K",
            unit: "",
            unit1: this.$t("ten thousands"),
          },
          text: this.$t("Reduced CO2 emissions"),
          subtext: "4,501.63 " + this.$t("Ton"),
          subtextname: this.$t("CO2 price today"),
          tongbi: this.$t("Year-on-year"),
          tongbiVal: "+32%",
          imgurl: require("./paiqiIcon.png"),
        },
        {
          title: this.$t("Predictive maint saves benefits"),
          value: {
            num: this.language == "ch" ? "2.4" : "24",
            unit: "",
            unit1: this.$t("ten thousands"),
          },
          text: "",
          subtext: "",
          tongbi: "",
          tongbiVal: "",
          imgurl: require("./setting.png"),
        },
      ];
      return topDataTop;
    },
    topData() {
      let topData = [
        {
          title: "月累计总电耗",
          value: { num: 4290, unit: "", unit1: "kWh" },
          same: "-14.9",
          sequential: "6",
        },
        {
          title: "本月总电费",
          value: { num: 2450, unit: "", unit1: "万元" },
          same: "-15.3",
          sequential: "5",
        },
        {
          title: "月累计吸气",
          value: { num: 1030, unit: "", unit1: "Nm³" },
          same: "-14.9",
          sequential: "3",
        },
        {
          title: "月吸气电耗",
          value: { num: 4.17, unit: "", unit1: "kWh/Nm³" },
          same: "-14.9",
          sequential: "3",
        },
        {
          title: "月吸气电耗",
          value: { num: 2.08, unit: "", unit1: "元/Nm³" },
          same: "-14.9",
          sequential: "3",
        },
      ];
      return topData;
    },
    legendData9() {
      let legendData9 = [
        this.$t("Power before renovation"),
        this.$t("Actual power"),
      ];
      return legendData9;
    },
    legendData6() {
      let legendData6 = [
        this.$t("Screw pump motor"),
        this.$t("Screw pump motor rated power")
      ];
      return legendData6;
    },
    deviceInfo() {
      let deviceInfo = [
        { name: this.$t("Type"), value: this.equip_data.deviceProfileName },
        { name:"吸入流量", value: "300-1300 m3/h" },
        { name:"极限真空", value: "2.0 kPaA" },
        { name:"背压", value: "ATM～1200 mbarA" },
        { name:"电机功率", value: "37kw" },

        {
          name: this.$t("Equipment running time"),
          // value: "8708小时",
          value: "-",
        },
      ];
      return deviceInfo;
    },
    imgUrl(){
      let url = _.get(this.equip_data,['files','image',0,'url'],'')
      return url;
    }
  },
  watch: {
    language: {
      handler(val) {
        chart9("chart9", this.legendData9, this.data9[val]);
        chart6("chart6", this.legendData6, this.data6[this.language]);

      },
      deep: true,
    },
  },
  mounted() {
    chart9("chart9", this.legendData9, this.data9[this.language]);
    chart6("chart6", this.legendData6, this.data6[this.language]);
    if(this.$route.query.index){
      this.value = ["电力","制药","电力"][this.$route.query.index-1]
      this.value1 = ["凝汽器抽真空","制药蒸馏","湿法脱硫氧化"][this.$route.query.index-1]
    }

  },
};
</script>
<style scoped lang="scss">
.shouyi {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: space-between;
}
.info-bg {
  background: #f3f6f9;
}
</style>
